export default __webpack_public_path__ + "static/media/attendance.ad140e50.svg";